import React, { useState } from "react";
import styles from "./WhatWeDo.module.scss";
import { useTranslation } from "react-i18next";
function WhatWeDo({ content , body}) {
  // STATES
  // STORE STATES
  // HOOKS
  const { t } = useTranslation();
  const [activeCard, setActiveCard] = useState(1);
  // METHODS
  // EFFECTS
  // RENDER
  return (
    <div className={styles.what}>
      <div className={styles.whatContent}>
        <h2 className={styles.whatTitle}>{t("home.whatWeDoTitle")}</h2>
        <p className={styles.whatBody}>{body}</p>
      </div>
      <div className={styles.whatCardContainer}>
        {content?.map((card, index) => {
          return (
            <div
              key={index}
              onClick={() => {
                setActiveCard(index + 1);
              }}
              className={`${styles.whatCard} ${
                activeCard === index + 1 ? styles.whatCardActive : ""
              }`}
            >
              <span className={styles.whatCardNumber}>{index + 1}</span>
              <h3 className={styles.whatCardTitle}>{card.title}</h3>
              <p className={styles.whatCardBody}>{card.body}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
export default WhatWeDo;
